import { ComponentType } from '@angular/cdk/portal';
import {
  AfterViewInit, ApplicationRef, ChangeDetectorRef, Component, ComponentRef, createComponent,
  inject, Inject, Injector, OnDestroy, OnInit, TemplateRef
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogConfig, MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { DialogBoxBouton, DialogBoxBoutonTypeeEnum } from '../dialog-box-configuration';
import { MatIcon } from "@angular/material/icon";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { MatButton, MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";

export enum PegaseDialogType {
  INFO = 'INFO',
  ERROR = 'ERROR',
  WARN = 'WARN',
  SUCCESS = 'SUCCESS'
}

export class PegaseDialogConfig<T> extends MatDialogConfig {
  /**
   * type de modale INFO|ERROR|WARN|SUCCESS
   * obligatoire
   * permet de déterminer l'icône et la couleur
   */
  type!: PegaseDialogType;
  title?: string;
  noCloseButton?: boolean;
  buttons?: Array<DialogBoxBouton> = [];
  text?: string;
  templateRef?: TemplateRef<any>;
  declare data?: T;

  /**
   * si true, alors le contenu est projeté dans un mat-dialog-content, et un mat-dialog-actions intègre les boutons fournis.
   * si false, charge au contenu de fournir le mat-dialog-content. Ne pas fournir de liste de boutons dans ce cas, elle sera ignorée. (les boutons doivent alors être intégrés directement dan le contenu projeté)
   */
  projectionDansUnMatDialogContent?: boolean = true;
}

export class PegaseDialogConfigWithComponent extends PegaseDialogConfig<any> {
  component!: ComponentType<any>;
}

/**
 * Wrapper de dialog utilisé par dialogBoxService
 */
@Component({
  templateUrl: './pegase-dialog-wrapper.component.html',
  styleUrls: ['./pegase-dialog-wrapper.component.scss'],
  imports: [
    MatIcon,
    NgClass,
    MatDialogTitle,
    MatMiniFabButton,
    MatDialogClose,
    MatTooltip,
    NgTemplateOutlet,
    MatDialogContent,
    MatButton,
    MatDialogActions
  ],
  standalone: true
})
export class PegaseDialogWrapperComponent implements AfterViewInit, OnDestroy, OnInit {
  private static _id = 0;

  get id(): number {
    return PegaseDialogWrapperComponent._id
  }

  types = PegaseDialogType;
  buttonTypes = DialogBoxBoutonTypeeEnum;

  injecteurSousComposant?: Injector;

  componentInjecteRef?: ComponentRef<any>;
  dialogRef = inject(MatDialogRef<PegaseDialogWrapperComponent>);
  dialogConfiguration = inject<PegaseDialogConfigWithComponent>(MAT_DIALOG_DATA);
  private injector= inject(Injector);
  private _applicationRef = inject(ApplicationRef);
  private cd = inject(ChangeDetectorRef);
  constructor() {
    PegaseDialogWrapperComponent._id++
  }
  ngOnInit(): void {
    if (this.dialogConfiguration.component) {
      // On crée un injecteur qui fournira à la modale (le composant envoyé dans le ngComponentOutlet)
      // le token MAT_DIALOG_DATA pour une utilisation transparent côté dev (ressemblant à matDiaog.open()...)
      this.injecteurSousComposant = Injector.create({
        providers: [{
          provide: MAT_DIALOG_DATA,
          useValue: this.dialogConfiguration.data
        }],
        parent: this.injector
      });
      this.cd.detectChanges();
      const componentHost = document.getElementById('componentHost_' + this.id);
      if (!componentHost) {
        console.error('componentHost not found:', 'componentHost_' + this.id);
        return;
      }
      this.componentInjecteRef = createComponent(this.dialogConfiguration.component, { hostElement: componentHost, environmentInjector: this._applicationRef.injector, elementInjector: this.injecteurSousComposant });
      this._applicationRef.attachView(this.componentInjecteRef.hostView);

      this.cd.detectChanges();
    }
  }
  ngOnDestroy(): void {
    if (this.componentInjecteRef) {
      this.componentInjecteRef.destroy();
    }
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onClick(button: DialogBoxBouton) {
    if (button.action) {
      if (this.componentInjecteRef) {
        button.action(this.componentInjecteRef.instance);
      } else {
        button.action();
      }
    }
    if (button.closeOnClick) {
      this.dialogRef.close(button.returnValue);
    }
  }

  isDisabled(button: DialogBoxBouton): boolean {
    return button.disabledFn ? button.disabledFn(this.componentInjecteRef?.instance) : false;
  }
}
